<div class="error-page__image">
  <img src="/assets/img/4XX-artwork.png" />
</div>
<div class="error-page__dialog">
  <h1 class="error-page__hd">Something isn&#8217;t right</h1>
  <p class="error-page__text">
    This page doesn&#8217;t exist, please check the link and try again
  </p>
</div>
